import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { EvaluationQuestionRowComponent } from './evaluation-question-row.component';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { categoryProgress } from '@shared/evaluation-progress.utils';

@Component({
  selector: 'app-evaluation-category',
  templateUrl: './evaluation-category.component.html',
  styleUrls: ['./evaluation-category.component.scss'],
  imports: [EvaluationQuestionRowComponent, NgbTooltipModule],
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: true,
})
export class EvaluationCategoryComponent {
  @Input() categoryData: any;
  @Input() index = 0;
  @Input() locked = false;
  @Input() reviewMode = false;
  @Input() signed = false;
  @Input() missingIds = new Set<string>();
  @Input() completedIds = new Set<string>();
  @Output() changed = new EventEmitter<void>();

  protected expanded = true;

  protected progress(): number {
    return categoryProgress(this.categoryData?.answers || []);
  }

  protected badgeClass(): string {
    const p = this.progress();
    if (p === 100) return 'bg-success';
    if (p > 0) return 'bg-warning text-dark';
    return 'bg-light text-dark border';
  }
}
